import { useMemo } from 'react';

import {
  GENERATION_TOOL,
  getInfinityTools,
  isDataDrivenGenerationTool,
  isMixtureTool,
} from 'src/data/generationTool';

/**
 * Returns a memoized array of generation tools sorted by groups and tools order
 * @returns {GENERATION_TOOL[]} - Array of generation tools
 */
export const useInfinityGenerationTools = () => {
  return useMemo(() => {
    const infinityTools = getInfinityTools();
    const filtered = infinityTools.filter(
      (tool) => isDataDrivenGenerationTool(tool) || isMixtureTool(tool)
    );

    return [GENERATION_TOOL.basicContentImprover, ...filtered];
  }, []);
};
